import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import '../styles/Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="header">
      <div className="header-container">
        <div className="logo">
          <span className="logo-text">DIGITRONICKS</span>
        </div>
        
        <button 
          className="menu-toggle"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Toggle menu"
        >
          {isMenuOpen ? <X size={28} /> : <Menu size={28} />}
        </button>
        
        <nav className={`nav ${isMenuOpen ? 'nav-open' : ''}`}>
          <a href="#overview" onClick={() => setIsMenuOpen(false)}>Overview</a>
          <a href="#domains" onClick={() => setIsMenuOpen(false)}>Domains</a>
          <a href="#services" onClick={() => setIsMenuOpen(false)}>Services</a>
          <a href="#clients" onClick={() => setIsMenuOpen(false)}>Clients</a>
          <a href="#contact" onClick={() => setIsMenuOpen(false)}>Contact</a>
        </nav>
      </div>
    </header>
  );
};

export default Header;